var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVirtualBackground = function SvgVirtualBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.91 19.8"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".virtual-background_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "virtual-background_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "virtual-background_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "virtual-background_svg__cls-1",
    d: "M23.64 0H2.27A2.29 2.29 0 0 0 0 2.27v15.26a2.29 2.29 0 0 0 2.27 2.27h21.37a2.28 2.28 0 0 0 2.27-2.27V2.27A2.28 2.28 0 0 0 23.64 0ZM2.22 1.46h21.37a.74.74 0 0 1 .75.76v11.32l-3.78-3.1-3.93 3.2-8.3-7.8-6.87 6.37v-10a.75.75 0 0 1 .76-.75Zm0 16.77a.74.74 0 0 1-.76-.76v-3.33l6.87-6.35 11.12 10.44Zm21.37 0h-2.08l-3.81-3.58 2.86-2.37 3.78 3.05v2.14a.73.73 0 0 1-.75.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "virtual-background_svg__cls-1",
    d: "M16.77 9a3 3 0 0 0 3-3 3 3 0 1 0-5.95 0 3 3 0 0 0 2.95 3Zm0-4.59A1.57 1.57 0 1 1 15.2 6a1.56 1.56 0 0 1 1.57-1.56Z"
  })))));
};
export default SvgVirtualBackground;